import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _createForOfIteratorHelper from "@babel/runtime/helpers/esm/createForOfIteratorHelper";
import { Editor, Range } from 'slate';

// modified on the basic of slate function Editor.unwrapNodes
// todo: split the unwrap by type the node which nearest to the selection

var unwrapNodesByTypeAtRange = function unwrapNodesByTypeAtRange(editor) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  Editor.withoutNormalizing(editor, function () {
    var _options$split = options.split,
      split = _options$split === void 0 ? false : _options$split,
      _options$voids = options.voids,
      voids = _options$voids === void 0 ? false : _options$voids,
      _options$mode = options.mode,
      mode = _options$mode === void 0 ? 'all' : _options$mode,
      _options$at = options.at,
      at = _options$at === void 0 ? editor.selection : _options$at;
    var match = options.match;
    if (!at) {
      return;
    }
    var matches = Editor.nodes(editor, {
      at: at,
      match: match,
      mode: mode,
      voids: voids
    });
    var node;
    var _iterator = _createForOfIteratorHelper(matches),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        match = _step.value;
        node = match;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    var pathRefs = Array.from([node], function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        p = _ref2[1];
      return Editor.pathRef(editor, p);
    });
    var _loop = function _loop() {
      var pathRef = _pathRefs[_i];
      var path = pathRef.unref();
      var _Editor$node = Editor.node(editor, path),
        _Editor$node2 = _slicedToArray(_Editor$node, 1),
        node = _Editor$node2[0];
      var range = Editor.range(editor, path);
      if (split && Range.isRange(range)) {
        range = Range.intersection(at, range);
      }
      Editor.liftNodes(editor, {
        at: range,
        match: function match(n) {
          return node.children.includes(n);
        },
        voids: voids
      });
    };
    for (var _i = 0, _pathRefs = pathRefs; _i < _pathRefs.length; _i++) {
      _loop();
    }
  });
};
export default unwrapNodesByTypeAtRange;